class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.navButtonsContainer = this.querySelector('.fc__nav');
    this.collections = this.querySelectorAll('.fc__collection');
    this.ctaLinks = this.querySelectorAll('.fc__cta-link');
  }

  connectedCallback() {
    this.navButtonsContainer?.addEventListener('click', (event) => {
      const button = event.target.closest('.fc__nav-button');
      if (button && !button.classList.contains('active')) {
        this.updateActiveState(button.dataset.collection, button);
      }
    });

    this.navButtonsContainer?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        this.handleKeyboardNavigation(event);
      }
    });
  }

  updateActiveState(activeCollection, activeButton) {
    this.toggleActiveClass(
      this.navButtonsContainer?.querySelectorAll('.fc__nav-button'),
      activeButton
    );
    this.toggleActiveClass(this.collections, null, activeCollection);
    this.toggleActiveClass(this.ctaLinks, null, activeCollection);

    // Update ARIA attributes
    this.navButtonsContainer
      ?.querySelectorAll('.fc__nav-button')
      .forEach((button) => {
        button.setAttribute(
          'aria-selected',
          button === activeButton ? 'true' : 'false'
        );
        button.setAttribute('tabindex', button === activeButton ? '0' : '-1');
      });

    this.collections.forEach((collection) => {
      const isActive = collection.dataset.collection === activeCollection;
      collection.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.ctaLinks.forEach((cta) => {
      const isActive = cta.dataset.collection === activeCollection;
      cta.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      cta.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }

  toggleActiveClass(elements, activeElement = null, activeData = null) {
    elements.forEach((el) => {
      const isActive = activeElement
        ? el === activeElement
        : el.dataset.collection === activeData;
      el.classList.toggle('active', isActive);
    });
  }

  handleKeyboardNavigation(event) {
    const buttons = Array.from(
      this.navButtonsContainer?.querySelectorAll('.fc__nav-button')
    );
    const currentIndex = buttons.findIndex(
      (button) => button.getAttribute('aria-selected') === 'true'
    );
    let newIndex =
      event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;

    if (newIndex < 0) newIndex = buttons.length - 1;
    if (newIndex >= buttons.length) newIndex = 0;

    buttons[newIndex].focus();
    buttons[newIndex].click();
  }
}

customElements.define('featured-collection', FeaturedCollection);
